import Component from '@Component';
import trackEvent from '@Core/tracking';

export default class TrackEvent extends Component {
  static selector = '[data-comp-track-event]'

  constructor(containerEl) {
    super(containerEl);
    this.eventName = this.$container.getAttribute('data-comp-track-event');
    // When the x-button component is compiled, the data-comp-track-event attribute
    // transforms into data-comp-track-event="data-comp-track-event"
    // The second condition in the if statement below catches that occurence
    if (!this.eventName || this.eventName === 'data-comp-track-event') {
      this.eventName = 'click';
    }
    this.attachEvent();
  }

  attachEvent() {
    this.$container.addEventListener(this.eventName, () => {
      const {
        eventCategory,
        eventAction,
        eventLabel,
      } = this.$container.dataset;
      trackEvent(eventCategory, eventAction, eventLabel);
    });
  }
}
